module.exports = __webpack_public_path__ + "static/media/store2.b50892b0.png";